"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.medalLockedMessage = exports.MEDAL_LOCKED_NAMES = exports.NICKNAME_CHANGE_CONFIRM_BODY = exports.nicknameLockedMessage = void 0;
exports.nicknameErrorMessage = nicknameErrorMessage;
const options_1 = require("./options");
const formatDate = (iso) => new Date(iso).toLocaleDateString(undefined, { month: 'long', day: 'numeric' });
/** Inline copy for a nickname the user can't have; null when the reason is not about the nickname. */
function nicknameErrorMessage(reason, availableAt) {
    switch (reason) {
        case 'nickname-invalid':
            return `Use ${options_1.NICKNAME_MIN_LENGTH}–${options_1.NICKNAME_MAX_LENGTH} letters, numbers or underscores`;
        case 'nickname-reserved':
            return 'That nickname is reserved';
        case 'nickname-inappropriate':
            return 'Please choose a different nickname';
        case 'nickname-taken':
            return 'That nickname is taken';
        case 'nickname-change-too-soon':
            return availableAt ? `You can change your nickname again on ${formatDate(availableAt)}` : 'You changed your nickname recently';
        default:
            return null;
    }
}
const nicknameLockedMessage = (availableAt) => `You can change your nickname again on ${formatDate(availableAt)}`;
exports.nicknameLockedMessage = nicknameLockedMessage;
exports.NICKNAME_CHANGE_CONFIRM_BODY = "A nickname can be changed only once every 30 days. You won't be able to change it again until then.";
exports.MEDAL_LOCKED_NAMES = { gold: 'a gold', silver: 'a silver', bronze: 'a bronze' };
/** Shown when a user taps a medal prop they have not won. */
const medalLockedMessage = (tier) => `Locked: win ${exports.MEDAL_LOCKED_NAMES[tier]} medal in a challenge to unlock`;
exports.medalLockedMessage = medalLockedMessage;
